/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	const slider = () => {
		if(document.querySelectorAll('.about-slider01').length) {
			document.querySelectorAll('.about-slider01').forEach((ele,idx) => {
				let sliderid = 'about-slider01_'+idx;
				let sliderclass = sliderid;

				ele.setAttribute('id',sliderid);
				sliderid = '#'+sliderid;

				ele.parentNode.querySelector(".about-slider01-control").classList.add(sliderclass);

				new Swiper(sliderid, {
					slidesPerView: 1,
					spaceBetween: 15,
					speed: 1000,
					autoplay: false,
					watchSlidesProgress: true,
					navigation: {
						nextEl: '.' + sliderclass + '.about-slider01-control .swiper-button-next',
						prevEl: '.' + sliderclass + '.about-slider01-control .swiper-button-prev',
					},
					pagination: {
						el: '.' + sliderclass + '.about-slider01-control .swiper-pagination',
						clickable: true,
					}
				});
			});
		}
	};

	slider();

})(window.FUNCTIONS);
